export const getEnrolmentRequestComments = (state) =>
  state.enrolmentRequestComment.enrolmentRequestCommentList;
export const getEnrolmentRequestCommentDetails = (state) =>
  state.enrolmentRequestComment.enrolmentRequestCommentDetails;
